{
    "addToCart": "Añadir a la cesta",
    "yes": "Si",
    "no": "No",
    "login": "Iniciar sesión",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "couponApplied": "Descuento aplicado!",
    "unappliedCoupon": {
        "title": "Descuento no aplicado",
        "description": "Escanea el producto correspondiente para recibir el descuento."
    },
    "done": "Terminar",
    "welcome": "Bienvenido",
    "welcomeScan": "Paga cómoda y fácilmente a través del autopago",
    "total": "Total",
    "toPayment": "Pagar",
    "back": "Volver",
    "quantityNeeded": "Cantidad necesaria",
    "confirmCart": "¿Se han escaneado todos sus artículos?",
    "interactWithTerminal": "Interactúa con el terminal de pago para finalizar tu compra",
    "endTitle": "¡Compra realizada con éxito!",
    "endSubtitle": "Ya puedes irte. Le agradecemos que haya comprado con nosotros!",
    "feedbackQuestion": "¿Cómo fue tu experiencia?",
    "endThanksForFeedback": "¡Gracias por tu feedback!",
    "endSeeYouLater": "Estamos deseando volver a verte.",
    "getReceipt": "Recibo",
    "scanQRCode": "Escanea este código QR para descargar tu recibo digital",
    "printReceipt": "Imprimir recibo",
    "receiptPrinted": "✔ Recibo impreso",
    "finalizeSession": "Finalizar sesión",
    "productNotFound": "¡Uy! No encontramos este artículo",
    "okDismiss": "OK",
    "somethingWentWrong": "Algo salió mal",
    "pleaseTryAgain": "Por favor, inténtalo de nuevo",
    "pleaseWait": "Un momento...",
    "tryAgain": "Vuelva a intentarlo",
    "reload": "Recargar",
    "stillThere": "¿Sigues ahí?",
    "continue": "Continuar",
    "startOver": "Empezar de nuevo",
    "scan": "Escanear un artículo para añadirlo a la cesta",
    "wantToStartOver": "¿Seguro que quieres empezar de nuevo?",
    "wantToStartOverDescription": "Perderá los artículos de su cesta escaneados y los descuentos aplicados.",
    "changeLanguage": "Cambiar de idioma",
    "ageVerification": "Escanear el DNI para verificar la edad",
    "scanId": "Para comprar este producto necesitas <strong>escanear tu identificación</strong> para verificar tu edad.",
    "holdIdSteady": "<strong>Nota:</strong> Por favor, mantenga su DNI firme hacia el escáner.",
    "sorryCantSell": "Lo sentimos, no podemos venderle este producto",
    "sorryCantSellDescription": "Sólo podemos vender este producto a mayores de 18 años.",
    "invalidId": "No hemos podido leer el ID que nos has proporcionado. Por favor, inténtelo de nuevo.",
    "verificationSuccessful": "Verificación correcta.",
    "startShopping": "Empezar a comprar",
    "startShoppingKitchen": "Pedir comida",
    "wantToDeleteLineItem": "¿Estás seguro de que quieres borrar el elemento?",
    "wantToDeleteLineItemDescription": "El producto se eliminará de su carrito.",
    "promotionsDontWork": "<strong>Nota:</strong> Los productos en promoción aún no funcionan con autofacturación.",
    "addToBasket": "Añadir",
    "promo": "Promo",
    "product": "Producto",
    "productAdded": "¡Producto añadido!",
    "product_other": "Productos",
    "operatorModeDialog": {
        "title": "¿Necesita ayuda?",
        "description": "Escanee su tarjeta de empleado para ver más acciones."
    },
    "orderList": {
        "collapseDetails": "Colapsar",
        "expandDetails": "Ampliar",
        "details": "Detalles",
        "title": "Órdenes"
    },
    "checkoutError": {
        "default": "Oops, su pago ha fallado. Por favor, inténtelo de nuevo.",
        "AbortedByUser": "El pago ha sido cancelado, por favor inténtelo de nuevo.",
        "PaymentDeviceNotFound": "No se ha encontrado ningún terminal de pago para este SCO.",
        "CouponNotFound": {
            "title": "Cupón no encontrado",
            "description": "Este cupón no se puede aplicar porque no se ha encontrado."
        },
        "CouponNotApplicable": {
            "title": "Cupón no aplicable",
            "description": "Este cupón no corresponde a ningún artículo de su carrito. Por favor, escanee primero el producto."
        },
        "CouponExpired": {
            "title": "Cupón caducado",
            "description": "Este cupón no se puede aplicar porque ha caducado."
        },
        "CouponAlreadyRedeemed": {
            "title": "Cupón ya utilizado",
            "description": "Este cupón no se puede aplicar porque ya ha sido utilizado."
        },
        "CouponRedemptionFailed": {
            "title": "Error al aplicar el cupón",
            "description": "El cupón no se ha podido aplicar. Por favor, inténtelo de nuevo."
        }
    },
    "operatorMode": "Modo operador",
    "operator": {
        "configuration": {
            "title": "Configuración",
            "individualConfig": {
                "title": "Configuración de SCO"
            },
            "storeConfig": {
                "title": "Configuración del punto de venta"
            },
            "status": {
                "label": "SCO habilitado",
                "confirmDisable": "¿Estás seguro/a de que deseas desactivar el SCO?",
                "confirmEnable": "¿Estás seguro/a de que deseas activar el SCO?"
            },
            "cartCheck": {
                "label": "Comprobación del carrito habilitada",
                "confirmDisable": "¿Estás seguro que deseas desactivar la comprobación del carrito?",
                "confirmEnable": "¿Estás seguro que deseas sactivar la comprobación del carrito?"
            }
        },
        "hardware": {
            "title": "Hardware",
            "lamp": "Lámpara",
            "printer": "Impresora",
            "scanner": "Escáner",
            "red": "Rojo",
            "green": "Verde",
            "print": "Imprimir recibo ficticio",
            "clear": "Borrar",
            "blink": "Parpadear",
            "paymentTerminal": "Terminal de pago",
            "login": "Iniciar sesión",
            "paymentDeviceConfig": {
                "currentIp": "Dirección IP actual",
                "ipLabel": "Nueva dirección IP",
                "invalidIp": "Dirección IP no válida",
                "setIp": "Establecer IP",
                "probe": "Sondear",
                "probeSucceeded": "Sondeo correcto",
                "probeFailed": "Sondeo fallido",
                "loginSucceeded": "Sesión iniciada correctamente",
                "loginFailed": "Error al iniciar sesión: {{reason}}",
                "status": "Estado",
                "statuses": {
                    "ready": "Listo",
                    "requiresLogin": "Requiere inicio de sesión",
                    "unreachable": "Inaccesible"
                },
                "ipUpdated": "Dirección IP actualizada",
                "ipUpdateFailed": "No se pudo actualizar la dirección IP: {{reason}}",
                "alterIp": "Cambiar IP",
                "dialogTitle": "IP del terminal de pago",
                "close": "Cerrar"
            }
        },
        "systemInformation": {
            "title": "Información del sistema",
            "deviceId": "ID de dispositivo",
            "cashRegisterId": "ID de caja registradora SAP",
            "paymentDeviceId": "ID del dispositivo de pago",
            "paymenetDeviceIp": "IP del dispositivo de pago",
            "runningVersion": "Versión en ejecución",
            "storeId": "ID de la tienda",
            "productPresetIds": "ID de preajuste del producto",
            "kitchenMenuId": "ID de The Kitchen menú",
            "tenant": "Arrendatario"
        }
    },
    "order": "Orden",
    "order_other": "Órdenes",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Agrupar por algo",
        "scoId": "Autocobro",
        "category": "Categoría"
    },
    "productCategory": {
        "label": "Category",
        "ABF": "Waste",
        "BTRM": "Operating resources",
        "BUCH": "Books",
        "CBAU": "Compatible unit",
        "CH00": "CH Contract management",
        "CONT": "KANBAN container",
        "COUP": "Coupon",
        "DIEN": "Service not ordered",
        "DLU1": "Service ordered",
        "EPA": "Equipment package",
        "ERSA": "Spare parts",
        "FERT": "Finished product",
        "FGTR": "Beverages",
        "FHMI": "Production aids",
        "FOOD": "Food (fresh food excl.)",
        "FRIP": "Fresh products",
        "HALB": "Semi-finished product",
        "HAWA": "Merchandise",
        "HERS": "Manufacturer part",
        "HIBE": "Auxiliary/operating materials",
        "IBAU": "Maintenance assembly",
        "INTR": "Intra material",
        "KMAT": "Configurable material",
        "LEER": "Empties",
        "LEIH": "Returnable packaging material",
        "LGUT": "Empties (after VOLL)",
        "MODE": "Fashion (seasonal)",
        "MPO": "Material planning object",
        "NLAG": "Non-storage material",
        "NOF1": "Non-food",
        "PIPE": "Pipeline material",
        "PLAN": "Merchandise (planned)",
        "PRES": "Press",
        "PROC": "Process material",
        "PROD": "Product group",
        "ROH": "Raw material",
        "TBAK": "Tobacco",
        "UNBW": "Unvalued material",
        "VBFO": "Consumable material FOOD",
        "VERP": "Packaging",
        "VKHM": "Additives",
        "VOLL": "Full product",
        "WERB": "Advertising material",
        "WERT": "Valuable material",
        "WETT": "Competitor product",
        "ZAUF": "Expense item",
        "ZAUS": "Press issue",
        "ZFRG": "Franchising fees",
        "ZGIF": "Ravita gift cards",
        "ZILV": "AGS: International service contract",
        "ZITP": "AGS: IT projects",
        "ZLEI": "Leihgut Kiosk AG",
        "ZLOG": "Services Logistics",
        "ZMFE": "AGS: Management fee",
        "ZOBJ": "Press - Object",
        "ZRAV": "Ravita PinCodes",
        "ZSER": "AGS: Service articles"
    },
    "totalRevenue": "Ingresos totales",
    "needReceipt": "<strong>¿Necesitas un recibo?</strong> Puedes encontrarlo en la app en Ajustes > Historial de compras.",
    "orderNumber": "Orden",
    "takeReceipt": "<strong>Importante</strong>: Por favor, lleve su el billete de pedido y entrégueselo al personal de cocina cuando recoja sus artículos.",
    "paymentSimulator": "Simulador de pago",
    "success": "Éxito",
    "failure": "Fracaso",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Volver a la cesta",
        "productUnavailable": "No disponible",
        "allergens": "Alérgenos",
        "nutritionalInformation": "Ingredientes y origen",
        "productInformation": "Información del producto",
        "upsellingTitle": "¿Quieres algo más con eso?"
    },
    "availableAtAvec": "Disponible en esta Avec",
    "kitchenDescription": "Presiona el botón The Kitchen para abrir el menú",
    "unknown": "Desconocido",
    "dateRangePicker": {
        "from": "De",
        "to": "A"
    },
    "outOfOrder": {
        "title": "¡Vaya! Tenemos un problema",
        "subtitle": "El autopago está temporalmente fuera de servicio, pero estamos trabajando duro para solucionarlo."
    },
    "cartCheckTriggered": "Su carrito ha sido seleccionado al azar para una revisión manual. Espere a que el personal se acerque."
}
